export enum PageConfigurationTypes {
  INDIVIDUAL = 'INDIVIDUAL',
  NON_INDIVIDUAL = 'NON_INDIVIDUAL',
  ACCOUNT = 'ACCOUNT',
  GOAL = 'GOAL',
  HOUSEHOLD = 'HOUSEHOLD',
  SUB_ACCOUNT = 'SUB_ACCOUNT',
  ACCOUNT_GROUP = 'ACCOUNT_GROUP',
}

export enum OptionTypes {
  BOOLEAN = 'BOOLEAN',
  PLAIN_TEXT_FIELD = 'PLAIN_TEXT_FIELD',
  BASIC_FIELD = 'BASIC_FIELD',
  SELECT_FIELD = 'SELECT_FIELD',
  TRANSLATED_STRING = 'TRANSLATED_STRING',
  VALIDATED_TEXT_FIELD = 'VALIDATED_TEXT_FIELD',
  OPTIONAL_TRANSLATED_STRING = 'OPTIONAL_TRANSLATED_STRING',
  ARRAY = 'ARRAY',
  TABLE = 'TABLE',
  ATTACHMENT = 'ATTACHMENT',
  WORKFLOW_SELECT_FIELD = 'WORKFLOW_SELECT_FIELD',
  HTML_TEMPLATE = 'HTML_TEMPLATE',
  CHECKBOX = 'CHECKBOX',
  COMBINED_FIELDS = 'COMBINED_FIELDS',
}

export enum PageConfigurationStates {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

import type { TranslatedString } from './shared';

export type WidgetOptions = {
  key?: string;
  label?: TranslatedString;
  description?: TranslatedString;
  info?: TranslatedString;
  showIf?: any;
  showWith?: string;
  requiredIf?: any;
  optionType: OptionTypes;
  default: any;
  options?: any;
  removeFromPages?: PageConfigurationTypes[];
  showBasedOnCustodianConnection?: any[];
  showCustomField?: boolean;
  replaceCustomField?: boolean;
  customFieldFilter?: any;
  value?: any;
  valid?: boolean;
  mobileTableView?: WidgetOptions;
};
